import { Modal, Spin } from 'antd';
import cn from 'classnames';

import { CloseIconsForModalWithDataTestId } from '@app/components';
import { RecordTagsModal } from '@app/components/RecordModal/components/RecordTagsModal';
import { PF } from '@app/components/RecordModal/data/constants';
import {
  useRecordModal,
  useRecordModalEffects,
} from '@app/components/RecordModal/hooks';
import { Sidebar } from '@app/components/RecordModal/ui/Sidebar';

import type { FC } from 'react';

import '@app/components/RecordModal/styles/RecordModal.scss';

export const RecordModal: FC = () => {
  const {
    isOpen,
    onCancel,
    onSelectTab,
    tab,
    Content,
    isLoading,
    queryRecordIdHandler,
    confirmUnsavedData,
    confirmWarnings,
  } = useRecordModal();

  useRecordModalEffects({ queryRecordIdHandler });

  return (
    <>
      {/* Окно тегов живёт рядом с модалкой записи: оно открывается уже после
          того, как новая запись создана и модалка закрыта (us/11144). */}
      <RecordTagsModal />
      <Modal
        data-testid="record-popup"
        open={isOpen}
        onCancel={onCancel}
        classNames={{ content: `${PF}__content`, body: `${PF}__body` }}
        className={`${PF}__dialog`}
        footer={null}
        destroyOnHidden
        closeIcon={<CloseIconsForModalWithDataTestId />}
        modalRender={(modal) => (
          <div className={`${PF}__modal-wrapper`}>{modal}</div>
        )}
      >
        <div className={cn(`${PF}__loading`, { 'display-none': !isLoading })}>
          <Spin size="default" spinning />
        </div>
        <Sidebar tab={tab} onSelectTab={onSelectTab} disabled={isLoading} />
        <div className={`${PF}__content-wrapper`}>
          <Content
            onCancel={onCancel}
            onSelectTab={onSelectTab}
            confirmUnsavedData={confirmUnsavedData}
            confirmWarnings={confirmWarnings}
          />
        </div>
      </Modal>
    </>
  );
};
